module.exports = __webpack_public_path__ + "img/404.4693ace6.png";